import { z } from 'zod';
import { baseObjectSchema } from '../baseSchemas';

export const getDocumentSeriesSchema = z.array(
  baseObjectSchema.extend({
    code: z.string().optional(),
    name: z.string().optional(),
    prefix: z.string().optional(),
    suffix: z.string().optional(),
    sequence: z.number(),
    isCancelingSeries: z.boolean(),
    hasAutomaticNumbering: z.boolean(),
  })
);

export type GetDocumentSeriesResponse = z.infer<typeof getDocumentSeriesSchema>;
